import { defineStore } from 'pinia';
import { ref } from 'vue';

type NotificationType = 'success' | 'error' | 'warning' | 'info';

interface NotificationOptions {
  message: string;
  type?: NotificationType;
  timeout?: number;
}

export const useNotificationStore = defineStore('notification', () => {
  const show = ref(false);
  const message = ref('');
  const color = ref<NotificationType>('success');
  const timeout = ref(3000);

  function showNotification({ message: msg, type = 'success', timeout: customTimeout }: NotificationOptions) {
    message.value = msg;
    color.value = type;
    if (customTimeout) timeout.value = customTimeout;
    show.value = true;
  }

  function hideNotification() {
    show.value = false;
  }

  return {
    show,
    message,
    color,
    timeout,
    showNotification,
    showSuccessNotification: (message: string) => showNotification({ message, type: 'success' }),
    showErrorNotification: (message: string) => showNotification({ message, type: 'error' }),
    showWarningNotification: (message: string) => showNotification({ message, type: 'warning' }),
    showInfoNotification: (message: string) => showNotification({ message, type: 'info' }),
    hideNotification,
  };
});
